// Shared data, animation variants and timing constants for the landing page sections.
import { Gift, Images, CalendarClock, Lock, Heart, Briefcase, Star, Sparkles, Send, Hourglass, Share2, Bell } from 'lucide-react';

// --- Timing constants (ms) ---
export const COUNT_UP_DURATION = 1200;
export const DEMO_STEP_DELAY = 1600;

// --- Reusable framer-motion variants ---
export const FADE_UP = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
};

export const SCALE_IN = {
  initial: { opacity: 0, scale: 0.96 },
  animate: { opacity: 1, scale: 1 },
};

export const CARD_RISE = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

// --- Imagery ---
export const IMG = {
  wedding:
    'https://images.unsplash.com/photo-1544717304-14d94551b7dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwYnJpZGUlMjBncm9vbSUyMGhhcHB5fGVufDB8fHx8MTc4MTQ3MDc1NXww&ixlib=rb-4.1.0&q=85',
  graduation:
    'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxncmFkdWF0aW9uJTIwYWNoaWV2ZW1lbnQlMjBoYXBweXxlbnwwfHx8fDE3ODE0NzA3NTV8MA&ixlib=rb-4.1.0&q=85',
  birthday:
    'https://images.unsplash.com/photo-1699730186236-6abe2a515208?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxqb3lmdWwlMjB3b21hbiUyMHJlY2VpdmluZyUyMGElMjBzdXJwcmlzZSUyMGdpZnQlMjBzbWlsaW5nJTIwd2FybXxlbnwwfHx8fDE3ODE0NzA3MzV8MA&ixlib=rb-4.1.0&q=85',
};

export const OCCASIONS = [
  { title: 'Birthdays', desc: 'The guessing game begins', image: IMG.birthday, span: 'lg:col-span-2 lg:row-span-2' },
  { title: 'Weddings', desc: 'Celebrate forever', image: IMG.wedding, span: 'lg:col-span-2' },
  { title: 'Achievements', desc: 'Honour the milestone', image: IMG.graduation, span: '' },
  { title: 'Friend Appreciation', desc: 'Just because', icon: Heart, span: '' },
  { title: 'Momentous Days', desc: 'Anniversaries & more', icon: Star, span: '' },
  { title: 'Corporate', desc: 'Reward your people', icon: Briefcase, span: '' },
];

export const BRANDS = ['Amazon', 'Starbucks', 'Woolworths', 'Apple'];

export const DEMO_STEPS = [
  { n: '01', title: 'Add photos, videos & a message', body: 'Build a story from your favourite shared memories — this is the real gift.', icon: Images },
  { n: '02', title: 'Add a gift card — optional', body: 'Want to? Attach one from any store: Amazon, Starbucks, a local boutique. Totally optional.', icon: Gift },
  { n: '03', title: 'Schedule & stay a mystery', body: 'Pick the perfect delivery time and drop a teasing hint. Your name stays locked until the reveal.', icon: Lock },
  { n: '04', title: 'They watch the countdown', body: 'A ticking timer and one hint — the group chat starts guessing who it could be.', icon: CalendarClock },
  { n: '05', title: 'The vault opens itself', body: 'Timer hits zero. Your story unlocks — photos, video, message, and the gift card if you added one.', icon: Sparkles },
  { n: '06', title: 'You get the ping', body: 'The instant they open the vault, you\'re notified — so you feel the rush of the reveal from wherever you are.', icon: Bell },
  { n: '07', title: 'They share the joy', body: 'The best reveals get shared — and the story lives on long after the moment.', icon: Share2 },
];

// Stats validated in the UNWP brand positioning research.
export const STATS = [
  { value: '£7B', label: 'spent on gift cards in the UK every year' },
  { value: '92%', label: 'of people prefer experiences over things' },
  { value: '41%', label: 'of gift card value is wasted or forgotten' },
];

// Maps the icon names stored in mockData.howItWorksSteps to lucide components.
export const HOW_ICON_MAP = { ShoppingBag: Gift, Images, Send, Hourglass, Sparkles, Share: Share2, Bell, Lock };
